import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";

import Unreal_Engine_Development from "../../../assets/Services/Arcade_dev/Unreal_Engine_Development.png";
import Arcade_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png";
import Bingo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png";
import Board_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png";
import Ludo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png";
import Rummy_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png";
import Poker_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png";
import Casino_Game_Development from '../../../assets/Services/Board_game_Dev/Casino_Game_Development.png'

import Access_to_Distinguished_Expertise from '../../../assets/Services/Board_game_Dev/Exp_raiden/Access_to_Distinguished_Expertise.svg'
import Advanced_Technology_Implementation from '../../../assets/Services/Board_game_Dev/Exp_raiden/Advanced_Technology_Implementation.svg'
import Complete_regional_adaptation from '../../../assets/Services/Board_game_Dev/Exp_raiden/Complete_regional_adaptation.svg'
import Expert_Consultation_on_Strategic_Issues from '../../../assets/Services/Board_game_Dev/Exp_raiden/Expert_Consultation_on_Strategic_Issues.svg'
import Pioneering_Game from '../../../assets/Services/Board_game_Dev/Exp_raiden/Pioneering_Game-play_Innovation.svg'

import Audio_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Audio_&_Sound.svg'
import Concept_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Concept_&_Validation.svg'
import Marketing_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Marketing_&_Launch.svg'
import Story_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Story_&_World-Building.svg'
import Systems_ from '../../../assets/Services/Board_game_Dev/Our_Board_Game_Development_Process/Systems_&_Backend.svg'

import Mask1 from '../../../assets/Services/Board_game_Dev/client/Mask1.png'
import Mask2 from '../../../assets/Services/Board_game_Dev/client/mask2.png'

import Art_ from '../../../assets/Services/Board_game_Dev/Board_game/Art_&_Animation.png'
import End_to_End_solution from '../../../assets/Services/Board_game_Dev/Board_game/End_to_End_solution.png'
import Muliti_infrastructure from '../../../assets/Services/Board_game_Dev/Board_game/Muliti_infrastructure.png'
import Multi from '../../../assets/Services/Board_game_Dev/Board_game/Multi-platform_dev.png'
import Visual from '../../../assets/Services/Board_game_Dev/Board_game/Visual&gameplay.png'


import big from '../../../assets/Services/Game_page/Board/big.png'
import icon from '../../../assets/Services/Game_page/Board/one.png'
import icon2 from '../../../assets/Services/Game_page/Board/two.png'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";

const BoardGameDev = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: "Multi-Platform Development    ",
      desc: "   Our scalable frameworks ensure smooth performance across devices as we design games for cross-platform compatibility, including web browsers, iOS, and Android.  ",
      img: Multi,
    },
    {
      title: "  Visual & Gameplay Design  ",
      desc: " Our specialists architect both 2D and 3D environments with precision, implementing intuitive UI/UX systems. The result? Visually compelling interfaces optimized for user engagement and playability.    ",
      img: Visual,
    },
    {
      title: "   Multiplayer Infrastructure ",
      desc: " We integrate both real-time and asynchronous multiplayer frameworks, enabling global connectivity and competitive play. Our backend solutions are designed for stability and scalability, supporting smooth user interactions.    ",
      img: Muliti_infrastructure,
    },
    {
      title: "Art & Animation    ",
      desc: "The visual identity of your game will be unique and technically flawless thanks to high-fidelity assets and animation pipelines. Performance is maximized for each frame without compromising detail.     ",
      img:  Art_,
    },
    {
      title: " End-to-End Solutions   ",
      desc: " From initial concept documentation through QA and deployment, we deliver comprehensive services. You get a streamlined, professional process that takes your game efficiently to market.    ",
      img: End_to_End_solution,
    },
  ];

  const pokerdevcompany = [
      {
      title: "  Pioneering Game-play Innovation ",
      icon:Pioneering_Game ,
      desc: "Raiden prefers uniqueness in creativity when it comes to game design. We actively work to add interesting features and innovative mechanics. This dedication to uniqueness sets our product apart and improves the overall gaming experience, encouraging long-term user involvement.   ",
    },
    {
      title: "  Advanced Technology Implementation ",
      icon:Advanced_Technology_Implementation ,
      desc: " We take advantage of modern technological innovations, like safe digital asset management, innovative gaming capabilities, and dependable, scalable real-time infrastructure, to ensure peak performance and future adaptability.  ",
    },
    {
      title: "  Complete regional adaptation ",
      icon: Complete_regional_adaptation,
      desc: "Our approach combines subtle localization—regionally relevant payment methods, culturally sensitive design, and extensive multilingual support—to make sure your game has a significant impact on a wide range of international player communities.   ",
    },
    {
      title: "Expert Consultation on Strategic Issues   ",
      icon: Expert_Consultation_on_Strategic_Issues,
      desc: "As the project progresses from conception to market launch, we offer crucial strategic direction. Our skilled consultants make sure your project complies with current industry norms and is positioned to optimize its competitiveness.   ",
    },
    {
      title: "  Access to Distinguished Expertise ",
      icon:Access_to_Distinguished_Expertise ,
      desc: "Our professionals can produce a polished, reliable, and market-ready unity game with accuracy and efficiency because they have a wealth of knowledge and specialized skills.   ",
    },
  ];
 

  const pokerdevcompany2 = [     
    {
      title: "  Concept & Validation",
      icon: Concept_,
      desc: "   Every project starts with a spark. We brainstorm creative ideas, test their market potential, and shape a clear vision to guide the team from day one.  ",
    },
    {
      title: "Story & World-Building ",
      icon: Story_,
      desc: " Next, we build the heart of the game: its world and story. Our writers develop rich lore, unique characters, and a narrative that draws players into something memorable.    ",
    },
    {
      title: "  Systems & Backend",
      icon: Systems_,
      desc: " Behind every great game is solid tech. Our engineers design reliable servers, smooth multiplayer systems, and robust data management—so everything just works.    ",
    },
    {
      title: " Audio & Sound ",
      icon: Audio_,
      desc: " Sound matters. Our audio team crafts original music and immersive effects, creating an atmosphere that brings every moment to life.    ",
    },
    {
      title: "  Marketing & Launch",
      icon: Marketing_,
      desc: " Finally, we make sure your game gets noticed. From strategic marketing plans to eye-catching promos, we handle everything needed for a successful release.    ",
    },
  ]

  const gamedevservices = [
    {
      title: "Poker  Game Development  ",
      icon:Poker_Game_Development ,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Casino Game Development  ",
      icon: Casino_Game_Development,
      desc: " Deliver immersive casino classics—from slots to roulette and blackjack—integrated with secure wallets, tournament systems, live dealer support, and multilingual functionality, all within a compliance-ready framework. ",
      link: "/casino-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: "Unreal Engine Development",
      icon: Unreal_Engine_Development,
      desc: " With extensive expertise in Unreal Engine, we develop high-fidelity, performance-driven games. Our pipeline supports realistic rendering, advanced physics, and scalable multiplayer architectures, suitable for both PC and console.",
      link: "/unreal-game-development",
    },
    {
      title: "Ludo Game Development",
      icon: Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon:Rummy_Game_Development ,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  
 
  const clientexp = [
    {
      icon:Mask1,
      name: "Nishithul ",

      desc: "Our platform has benefited greatly from Raiden Labs' anti-fraud system and player activity tracking modules. Since adding these features, we have seen a sharp decline in questionable activity, and our game's overall security has significantly increased. Player confidence has also grown as a result of the secure payment gateway integration, increasing retention and general trust in our product.",
    },
    {
      icon:Mask2 ,
      name: "Jack  ",
      undername: " ",
      desc: " When we contacted Raiden Labs for a custom mobile bingo solution, their technical know-how was immediately apparent. Their strong grasp of both 2D and 3D game development, along with their use of cutting-edge technologies like WebSockets for real-time communication, allowed us to produce a truly immersive product. ",
    },
    
  ];
  const handleClick=(e)=>{
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    console.log("data subitted successfully")
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"      style={{ minHeight: "100vh"}}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">Board Game Development</h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              We design board games engineered to foster genuine social
              interaction and immersive engagement. Our approach prioritizes
              tactile components, robust mechanics, and precise craftsmanship—no
              shortcuts. Our dedication to quality control and creative design
              principles forms the foundation of every title we create. The
              integration of storytelling into the gameplay architecture
              elevates it above the status of an add-on.{" "}
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
          <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={big} style={{ width: "85%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Overview Of The Board Game Development
            </h2>
            <p className="mt-4  h1-para " >
              Our specialty at Raiden Labs is the complete development of
              tabletop games, using cutting-edge design and production
              techniques to turn ideas into completed goods. Our team oversees
              each step, guaranteeing that visual fidelity and strategic
              integrity are upheld at all times. Prototyping, graphic rendering,
              playtesting, component manufacturing, and concept development are
              all included in this.{" "}
            </p>

            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">
          Our Board Game Development Services
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          We manage every phase of development, transforming concepts for
          tabletop games into dependable online experiences. Our team makes sure
          your product satisfies industry standards for engagement and quality
          throughout the entire process.
        </p>
        <CoreSlider cards={cards} />
      </div>

       

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row align-items-center ">
            <div className="col-lg-6">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                What We Offer
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Unite with us for bespoke hall software engineered  for high
                performance, scalability, and a stimulating player experience.
                From conception and character design to multiplayer armature and
                live deployment, we deliver the complete technology stack so you
                can launch, contend, and dominate in any request.{" "}
              </p>
              <Link to="/request-quote">
                <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
                  TALK WITH OUR EXPERTS NOW!
                </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            The Raiden Edge: Advanced Tech and a Flawless Board Games
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge Blockchain gameplay 
            experience.
          </p>
          <CoreComponent32  />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal Board Game: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your Unity app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37  />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row align-items-center   flex-column-reverse  flex-lg-row">
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Secure Your Digital World
              </h2>
             <p className="h1-para text-white  lh-base" style={{ opacity: 0.6 }}>
                Protect your business from threats. Our security specialists
                provide robust solutions to safeguard your data and fortify your
                infrastructure, giving you peace of mind.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon2} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">
          Our Board Game Development Process
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          Our process focuses on transforming an initial concept into a finished
          product, building a compelling world and story while engineering the
          underlying technology, and finalizing the experience with
          comprehensive audio and a strategic launch plan.{" "}
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Our Other Game Developments</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We deliver a broad spectrum of game development services, leveraging
          advanced tools and technologies to build robust gaming experiences
          across multiple platforms and genres.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container  ">
        <h2 className="text-center lh-base h2-heading ">
          Experience Raiden’s Board Game Development
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          We are able to translate complicated concepts into dependable, useful
          frameworks for understanding technical and  industry-specific demands.
          Our comprehensive understanding benefits customers by ensuring
          reliable and effective solutions.
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-5 ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
     Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          Listen to people who have worked closely with us. In the board game manufacturing process, Raiden Labs' dedication to quality, innovation, and customer satisfaction is evident in these testimonies.
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BoardGameDev;
